import { hashCode } from "src/components/js/statics1";
import rasitusluokatJson from "src/data/json/rasitusluokat.json";

export default class betoniRasitusluokkaClass {
  constructor(arr) {
    this.rasitusluokat = [];
    if (arr != undefined) this.init1(arr);
    //this.pluku = "P0"; // TODO later
    //this.sideaine = 300; // TODO get autom sideaine or set for HB
  }

  init1 = (rasitusluokatArr) => {
    if (rasitusluokatArr == null) return;
    const r = rasitusluokatArr;
    this.rasitusluokat = r;
    this.rasitusluokat.sort();
  };
  init2 = (rasitusluokatDelim) => {
    if (rasitusluokatDelim == null) return;
    const r = rasitusluokatDelim.split(",");
    this.rasitusluokat = r;
    this.rasitusluokat.sort();
  };

  remove(rasitusluokka) {
    if (rasitusluokka == null) return;
    rasitusluokka = rasitusluokka.trim();
    for (var i = 0; i < this.rasitusluokat.length; i++) {
      if (this.rasitusluokat[i].trim() === rasitusluokka) {
        this.rasitusluokat.splice(i, 1);
        i--;
      } else if (this.rasitusluokat[i].trim().indexOf(rasitusluokka) > 0) {
        this.rasitusluokat.splice(i, 1);
        i--;
      }
    }
  }

  toggle(rasitusluokka) {
    if (rasitusluokka == null) return;
    rasitusluokka = rasitusluokka.trim();
    for (var i = 0; i < this.rasitusluokat.length; i++) {
      const r = this.rasitusluokat[i].trim();
      if (r.indexOf(rasitusluokka) > -1) {
        this.remove(r);
        return;
      }
    }
    if (this.rasitusluokat.includes(rasitusluokka)) {
      this.remove(rasitusluokka);
    } else {
      this.add(rasitusluokka);
    }
  }

  add(rasitusluokka) {
    if (rasitusluokka == null) return;
    rasitusluokka = rasitusluokka.trim();
    if (!this.rasitusluokat.includes(rasitusluokka)) {
      this.rasitusluokat.push(rasitusluokka);
    }
  }

  get rasitusluokatString() {
    if (this.rasitusluokat == null || this.rasitusluokat.length === 0) return "";
    this.rasitusluokat.sort();
    // remove empty strings
    const r0 = this.rasitusluokat.filter((item) => item.trim() !== "");
    // remove duplicates
    const r1 = [...new Set(r0)];
    // join with comma
    const r2 = r1.join(", ");
    return r2;
  }

  get rasitusluokatString_Joined() {
    if (this.rasitusluokat == null || this.rasitusluokat.length === 0) return "";
    this.rasitusluokat.sort();

    let xStr = "";
    let x1 = "";
    let n1 = "";
    let c = 0;
    this.rasitusluokat.map((item) => {
      const x2 = item.slice(0, 2);
      const n2 = item.slice(2, 3);
      if (x1 != x2 || n1 != n2 - 1) {
        xStr = xStr + (c > 0 ? ", " : "") + item;
      } else {
        if (xStr.endsWith("-" + n1)) {
          xStr = xStr.slice(0, -2);
        }
        xStr = xStr + "-" + n2;
      }
      c = c + 1;
      x1 = x2;
      n1 = n2;
    });
    if (xStr.startsWith(",")) xStr = xStr.substring(1);
    return xStr;
  }

  getCatLabel(_rasitusluokkaCat) {
    var a = "";
    rasitusluokatJson.map((item) => {
      if (item.header === _rasitusluokkaCat) {
        a = item.label;
        return a;
      }
      return true;
    });
    return a;
  }
  getCatDesc(_rasitusluokkaCat) {
    var a = "";
    rasitusluokatJson.map((item) => {
      if (item.header === _rasitusluokkaCat) {
        a = item.desc;
        return a;
      }
      return true;
    });
    return a;
  }

  getLabel(_rasitusluokka) {
    if (_rasitusluokka == null) return "";
    var _rasitusluokkaCat = _rasitusluokka.substring(0, 2);
    if (_rasitusluokka.indexOf(",") > 0) _rasitusluokkaCat = "combo";
    var _label = "";
    rasitusluokatJson.map((item1) => {
      if (item1.header === _rasitusluokkaCat) {
        item1.items.map((item2) => {
          if (item2.rasitusluokka === _rasitusluokka) {
            _label = item2.label;
            return false;
          }
          return false;
        });
      }
      return false;
    });
    return _label;
  }

  get XC1() {
    return this.rasitusluokat.includes("XC1");
  }
  get XC2() {
    return this.rasitusluokat.includes("XC2");
  }
  get XC3() {
    return this.rasitusluokat.includes("XC3");
  }
  get XC4() {
    return this.rasitusluokat.includes("XC4");
  }
  get XD1() {
    return this.rasitusluokat.includes("XD1");
  }
  get XD2() {
    return this.rasitusluokat.includes("XD2");
  }
  get XD3() {
    return this.rasitusluokat.includes("XD3");
  }
  get XF1() {
    return this.rasitusluokat.includes("XF1");
  }
  get XF2() {
    return this.rasitusluokat.includes("XF2");
  }
  get XF3() {
    return this.rasitusluokat.includes("XF3");
  }
  get XF4() {
    return this.rasitusluokat.includes("XF4");
  }
  get XS1() {
    return this.rasitusluokat.includes("XS1");
  }
  get XS2() {
    return this.rasitusluokat.includes("XS2");
  }
  get XS3() {
    return this.rasitusluokat.includes("XS3");
  }
  get XA1() {
    return this.rasitusluokat.includes("XA1");
  }
  get XA2() {
    return this.rasitusluokat.includes("XA2");
  }
  get XA3() {
    return this.rasitusluokat.includes("XA3");
  }

  get hash() {
    let hash = 0;
    if (this.rasitusluokat.length === 0) return hash;
    for (let i = 0; i < this.rasitusluokat.length; i++) {
      hash += hashCode(this.rasitusluokat[i]);
    }
    return hash;
  }
}

export function getBetoniRasitusLuokatString(_rasitusluokat) {
  if (_rasitusluokat == null || _rasitusluokat.length === 0) return "";
  _rasitusluokat.sort();

  let xStr = "";
  let x1 = "";
  let n1 = "";
  let c = 0;
  _rasitusluokat.map((item) => {
    const x2 = item.slice(0, 2);
    const n2 = item.slice(2, 3);
    if (x1 != x2 || n1 != n2 - 1) {
      xStr = xStr + (c > 0 ? ", " : "") + item;
    } else {
      if (xStr.endsWith("-" + n1)) {
        xStr = xStr.slice(0, -2);
      }
      xStr = xStr + "-" + n2;
    }
    c = c + 1;
    x1 = x2;
    n1 = n2;
  });
  if (xStr.startsWith(",")) xStr = xStr.substring(1);
  return xStr;
}
